<template>
<div class="chapter">
<div class="inner_page">
<div class="prologue" id="prologue3">
<p class="centerImage"><img alt="image" id="img14" src="images/img14.jpg"/></p>
<h2 class="caption">Extract from author’s log book. First four flights.</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VulcanTestPilot_prologue3.vue?c8861338